export const SHOW_SESSION_EXPIRED_MODAL = 'SHOW_SESSION_EXPIRED_MODAL';
export const HIDE_SESSION_EXPIRED_MODAL = 'HIDE_SESSION_EXPIRED_MODAL';

export const showSessionExpiredModal = () => ({ type: SHOW_SESSION_EXPIRED_MODAL });
export const hideSessionExpiredModal = () => ({ type: HIDE_SESSION_EXPIRED_MODAL });
